<nav class="pagination" aria-label="Paginación">
  <button
    class="pagination__btn pagination__btn--prev"
    type="button"
    [disabled]="!hasPrev()"
    [attr.aria-disabled]="!hasPrev()"
    (click)="goTo(currentPage() - 1)"
    aria-label="Página anterior"
  >
    ‹
  </button>

  @for (page of visiblePages(); track $index) {
    @if (page === null) {
      <span class="pagination__ellipsis" aria-hidden="true">…</span>
    } @else {
      <button
        class="pagination__page"
        [class.pagination__page--active]="page === currentPage()"
        type="button"
        [attr.aria-current]="page === currentPage() ? 'page' : null"
        [attr.aria-label]="'Página ' + page"
        (click)="goTo(page)"
      >
        {{ page }}
      </button>
    }
  }

  <button
    class="pagination__btn pagination__btn--next"
    type="button"
    [disabled]="!hasNext()"
    [attr.aria-disabled]="!hasNext()"
    (click)="goTo(currentPage() + 1)"
    aria-label="Página siguiente"
  >
    ›
  </button>
</nav>
